import styled from 'styled-components';

export const Circle = styled.div`
    border-radius: 50%;
    width: 34px;
    height: 34px;
    padding: 10px;
    /* background: ${(props) => props.bg}; */
    border: 5px solid ${(props) => props.bg};
    /* color: #000; */
    font-size: ${(props) => props.textSize};
    font-family: Arial, sans-serif;
    display: flex;
    text-align: center;
    justify-content: center;
`;